/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i[_ngcontent-%COMP%]{color:#60bfd4;margin-left:5px;font-size:14px}"];
export { styles as styles };
